import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { Row } from "components/Containers";
import Tooltip from "components/Tooltip";
import Icon, { ICON_SIZE, ICON_TYPE } from "components/Icon";
import { formatDate } from "utils";
import { colors } from "style";

/**
 * ApplicantAppliedAt
 *
 * @param {Object} data
 */
const ApplicantAppliedAt = ({ data }) =>
  data?.appliedAt ? (
    <Row gap="0.4rem" noWrap>
      <div css={styles.icon_container}>
        <Tooltip tooltipId="Missions.Applicants.ApplicantAppliedAt.AppliedOn" key={data?.appliedAt} hideIcon>
          <Icon type={ICON_TYPE.listNumeric} size={ICON_SIZE.small} color="inherit" />
        </Tooltip>
      </div>

      {formatDate(data?.appliedAt, "MMM DD, YYYY", true, true)}
    </Row>
  ) : data?.pendingSince ? (
    <Row noWrap>
      <div css={styles.icon_container}>
        <Tooltip tooltipId="Missions.Applicants.ApplicantAppliedAt.PendingSince" hideIcon>
          <Icon type={ICON_TYPE.listNumeric} size={ICON_SIZE.small} color="inherit" />
        </Tooltip>
      </div>
      {formatDate(data?.pendingSince, "MMM DD, YYYY", true, true)}
    </Row>
  ) : null;

const styles = {
  icon_container: css`
    border-radius: 1rem;
    background: ${colors.grayAnatomyLight3};
    width: 3.5rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};

ApplicantAppliedAt.propTypes = {
  data: PropTypes.shape({
    appliedAt: PropTypes.string,
    pendingSince: PropTypes.string,
  }).isRequired,
};

export default ApplicantAppliedAt;
